<template>
    <div class="mission-item active" v-if="achievement.status == 1">
        <div class="mission-item-left d-flex">
            <div class="desc-img">
                <!-- <img src="/themes/web/assets/images/reward-unlock.svg" alt="">
                <div class="d-flex">
                    <span style="margin-right: 5px;">+{{ achievement.gem }}</span>
                    <img src="/themes/web/assets/images/gem.svg" alt="">
                </div> -->
                <AppIcon :src="$store.state.treasure_icon_url" :size="50" />
                <div class="text d-flex align-items-center justify-content-center gap-1">+{{ achievement.gem | toCommas }}
                    <AppIcon :src="$store.state.gem_icon_url" :size="15" />
                </div>
            </div>
            <div style="width: 600px;">
                <span class="mission-item-title">{{ $t(`${achievement.name}`) }}</span>
                <span>({{$t('level')}} {{ achievement.level }})</span>
                <div>{{ $t(achievement.desc) }}</div>
                <div class="d-flex mt-8">
                    <div class="progress flex m0">
                        <div class="progress-bar" :style="{'width':(100*achievement.process/achievement.max_process)+'%'}"></div>
                    </div>
                    <div class="ml-8">
                        <template v-if="achievement.process < achievement.max_process">
                            {{ achievement.process }}/{{ achievement.max_process }}    
                        </template>
                        <template v-else>
                            {{ achievement.max_process }}/{{ achievement.max_process }}  
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="">
            <button class="btn btn-main-sm" @click="claim(achievement)">
                {{ $t('claim') }}
            </button>
        </div>
    </div>    
    <div class="mission-item" v-else-if="achievement.status == 2">
        <div class="mission-item-left d-flex">
            <div class="desc-img">
                <AppIcon :src="$store.state.treasure_icon_url" :size="50" />
                <div class="d-flex">
                    <span style="margin-right: 5px;">+{{ achievement.gem }}</span>
                    <AppIcon :src="$store.state.gem_icon_url" :size="15" />
                </div>
            </div>
            <div style="width: 600px;">
                <span class="mission-item-title">{{ $t(`${achievement.name}`) }}</span>
                <span>({{$t('level')}} {{ achievement.level }})</span>
                <div>{{ $t(achievement.desc) }}</div>
                <div class="d-flex mt-8">
                    <div class="progress flex m0">
                        <div class="progress-bar" :style="{'width':(100*achievement.process/achievement.max_process)+'%'}"></div>
                    </div>
                    <div class="ml-8">
                        <template v-if="achievement.process < achievement.max_process">
                            {{ achievement.process }}/{{ achievement.max_process }}    
                        </template>
                        <template v-else>
                            {{ achievement.max_process }}/{{ achievement.max_process }}  
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="">
            <div class="mission-item-completed">{{$t('complete')}} <i class="lisa-icon-complete-large ml-8"></i></div>
        </div>
    </div>    
    <div class="mission-item" v-else>
        <div class="mission-item-left d-flex">
            <div class="desc-img">
                <img src="/themes/web/assets/images/reward-lock.svg" alt="">
                <div class="d-flex">
                    <span style="margin-right: 5px;">+{{ achievement.gem }}</span>
                    <AppIcon :src="$store.state.gem_icon_url" :size="15" />
                </div>
            </div>
            <div style="width: 600px;">
                <span class="mission-item-title">{{ $t(`${achievement.name}`) }}</span>
                <span>({{$t('level')}} {{ achievement.level }})</span>
                <div>{{ $t(achievement.desc) }}</div>
                <div class="d-flex mt-8">
                    <div class="progress flex m0">
                        <div class="progress-bar" :style="{'width':(100*achievement.process/achievement.max_process)+'%'}"></div>
                    </div>
                    <div class="ml-8">
                        <template v-if="achievement.process < achievement.max_process">
                            {{ achievement.process }}/{{ achievement.max_process }}    
                        </template>
                        <template v-else>
                            {{ achievement.max_process }}/{{ achievement.max_process }}  
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="">
            <div class="btn btn-main-sm" style="background-color: #C4C4C4;">{{ $t('claim') }}</div>
        </div>
    </div>    

</template>

<script>
    import {mapGetters} from 'vuex'
    import {claimAchievement} from "../../models/achievement";
    import {soundClick, soundGetReward, soundClaimKey, soundClaimGem} from '../../utils/utils';
    import AppIcon from "@/components/common/AppIcon.vue";

    export default {
        name: "AchievementItem",
        components: { AppIcon },
        props: ['achievement'],

        computed: {
            ...mapGetters([
                'user_info'
            ], () => {
                if (this.user_info) {
                    return this.user_info
                }

                return {
                    gem: 0
                }
            })
        },

        data() {
            return {};
        },

        created() {

        },

        configs() {
            return this.$store.state.configs
        },

        methods: {
            claim(achievement) {
                const that = this;
                that.getSoundClaimGem();
                claimAchievement({
                    id: achievement.id
                }).then((response) => {
                    if (response.data.code != 0) {
                        return;
                    }

                    that.achievement.status = response.data.results.status || '';

                    const new_gem = response.data.results.update_gem || 0;
                    const gem = response.data.results.gem_reward || 0;

                    that.user_info.gem = new_gem;

                    const gem_txt = gem > 0 ? '+' + gem : gem;

                    $('#congratulation_gem').text(gem_txt);
                    $('#getRewardedModal').modal('show');
                    
                    //location.reload();
                }).catch(({response}) => {
                    console.error(response);
                });
            },
            getSoundClick() {
                soundClick();
            },

            getSoundGetReward() {
                soundGetReward();
            },

            getSoundClaimKey() {
                soundClaimKey();
            },

            getSoundClaimGem() {
                soundClaimGem();
            }
        }
    }
</script>

<style scoped>
    .desc-img{
        margin-right: 25px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-self: flex-start;
        align-items: center;
        font-size: 15px;
        font-weight: 1000;
    }

    .text {
        font-weight: 700;
        font-size: 12px;
        line-height: 19px;
        color: #1B1B1B;
        text-align: center;
    }

</style>
